import React, { useCallback, useRef } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { formatDateFromFilterValue } from "@/pages/dashboard/utils/formatDate";
import useSelectorDataNew from "@/pages/dashboard/filterPageComponents/multiTimezone/hooks/useSelectorDataNew";
import { getDateDefault } from '../../utils/dateUtils';
import { shallowEqual, useSelector } from 'umi';



/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// daily筛选器继承逻辑
const NewUsersRetentionFilter = (props: any) => {
  const { filterConfirm, filterReset, filterInit, buttonLogConfig, type, openSticky = false } = props;
  // 筛选器路径
  const FILTER_PATH = `multiTimezone/newUsers/${type}`;
  const timeDiff = useRef<boolean>(false);
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const timeZone = useSelector((state: any) => (parseInt(state?.dashboardSetting?.gameConfig?.time_zone || '') || 0), shallowEqual);

  // 设置inputList
  const rangTime = {
    type: 'rangeDaily',
    key: 'rangeTime',
    default: getDateDefault({ timeType: 'day', timeZone, startNum: 14, endNum: 1 }),
  };

  const { selectorData } = useSelectorDataNew(type);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value, inputList,isHaveExtendFIlter) => {
    filterValueRef.current = value;
    // todo 锁定状态下如果锁定时间跟默认时间相同，是否需要单独处理，设置diff为false？
    filterInit({
      filterValue: formatDateFromFilterValue(value, 'Day'),
      [FORM_MAP.IS_INIT]: true,
      [FORM_MAP.RANGE_TIME_DIFF]: !isHaveExtendFIlter
    });
  }, [filterInit]);

  const onConfirm = useCallback((value) => {
    filterValueRef.current = value;
    const obj: any = {
      filterValue: formatDateFromFilterValue(value, 'Day')
    };
    if (timeDiff.current) {
      obj[FORM_MAP.RANGE_TIME_DIFF] = true;
    }
    filterConfirm(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj?.filterValue);
  }, [filterConfirm]);

  const onChange = useCallback((key) => {
    if (key === 'rangeTime' && !timeDiff.current) {
      timeDiff.current = true;
    }
  }, [filterReset]);

  const onReset = useCallback((value) => {
    filterValueRef.current = value;
    const obj = {
      filterValue: formatDateFromFilterValue(value, 'Day'),
      [FORM_MAP.RANGE_TIME_DIFF]: false
    };
    filterReset(obj);
    timeDiff.current = false;
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj?.filterValue, true);
  }, [filterReset]);

  return <Filter
    openSticky={openSticky}
    path={FILTER_PATH}
    latestDateType={'mt-register'}
    value={filterValueRef.current}
    // useOutInput={true}
    inputList={[rangTime]}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
    onChange={onChange}
    outSelector={selectorData}
    key={FILTER_PATH}
  />;
};

export default NewUsersRetentionFilter;
